export default __webpack_public_path__ + "static/bc_hu_5-b93edbe68c7f6378e85972f298d2e5ac.mp4";